<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:right-content="page.rightContent"
		>
			<template #extra-content>
				<div v-for="item in roomsData" :key="item.ID" class="row rooms align-left">
					<div class="columns column6 room-item">
						<div class="hidden-overflow">
							<nuxt-link :to="item.filename">
								<picture>
									<source :srcset="item.imageOverviewWebp" type="image/webp" />
									<source :srcset="item.imageOverview" />
									<img
										class="room-img"
										:src="item.imageOverview"
										:alt="item.imageOverviewAlt"
										loading="lazy"
									/>
								</picture>
							</nuxt-link>
						</div>
					</div>
					<div class="columns column6 room-item">
						<div class="content">
							<h3>
								<nuxt-link :to="item.filename">
									{{ item.title || item.header }}
								</nuxt-link>
							</h3>
							<div v-parse-links v-html="item.contentShort" />
							<div class="room-icons">
								<div v-if="item.pax" class="room-icon">
									<font-awesome-icon class="icon-margin" :icon="`fal fa-users`" size="1x" />
									<span>{{ item.pax }}</span>
								</div>
								<div v-if="item.surface" class="room-icon">
									<font-awesome-icon class="icon-margin" :icon="`fal fa-ruler-combined`" size="1x" />
									<span>{{ item.surface }}</span>
								</div>
							</div>
							<button-container>
								<nuxt-link :to="item.filename" class="button button-no-fill">
									{{ $t('viewThisRoom') }}
								</nuxt-link>
								<book-button v-if="item.bookingID" :roomid="item.bookingID" class="button">
									{{ $t('bookThisRoom') }}
								</book-button>
							</button-container>
						</div>
					</div>
				</div>
			</template>
		</main-content>

		<contentblocks
			v-if="page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:contentblocks-content="page.contentBlockContent"
		/>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection && page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletterForm.title"
			:content="defaults[locale].newsletterForm.content"
			:email="defaults[locale].newsletterForm.email"
			:button="defaults[locale].newsletterForm.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: roomsData } = await useWebsiteFetch('rooms', {
	query: { language: locale.value },
	key: `${locale.value}/rooms`,
});
</script>

<style lang="scss" scoped>
.row.rooms {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-flow: row wrap;
	background: rgb(227 227 239 / 90%);
	padding: 20px 10px;
	width: calc(100% - 40px);
	margin: 20px auto 60px;
	box-shadow: 0 18px 26px rgb(0 0 0 / 15%);
}

.room-icons {
	display: flex;
	flex-flow: wrap row;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	margin: 0 0 20px;

	.room-icon {
		margin: 0 20px 0 0;
	}

	span {
		font-size: 12px;
	}

	svg {
		color: $primary-color;
	}
}

.column6 {
	float: none;
	margin: 25px 0 50px;
	width: 49%;
	vertical-align: top;

	.hidden-overflow {
		overflow: hidden;
	}
}

@media (max-width: 960px) {
	.rooms .column6 {
		width: 100%;
		padding: 20px 0;
		margin: 0;
	}
}
</style>
